module.exports = __webpack_public_path__ + "static/img/bg_de.be112e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hlSaled-2025/bg_de.png
// module id = dInF
// module chunks = 1